/**
 * @see https://github.com/ueberdosis/tiptap/blob/main/packages/extension-youtube/src/utils.ts
 */
export const YOUTUBE_REGEX =
  /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)\/(?!channel\/)(?!@)(.+)?$/;

export const YOUTUBE_EMBED_REGEX =
  /^https:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]+$/;
export const VIDEO_ID_REGEX = /(?:v=|shorts\/)([-\w]+)/gm;
